// extracted by mini-css-extract-plugin
module.exports = {"item-wrapper":"Item_item-wrapper__1a3Yt","item":"Item_item__RRdW6","image":"Item_image__2U944","text":"Item_text__cg15e"};